import React from 'react';

/**
 * Inline SVG brand glyphs for job boards whose logos aren't on the
 * Simple Icons CDN (LinkedIn was pulled for trademark reasons, etc.).
 * Each glyph renders inside a square of the given `size`.
 */
const BrandLogos = {
  linkedin: ({ size = 36 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="24" height="24" rx="3" fill="#0A66C2" />
      <path
        fill="#FFFFFF"
        d="M6.94 8.5a1.94 1.94 0 1 1 0-3.88 1.94 1.94 0 0 1 0 3.88ZM5 9.95h3.88V19H5V9.95Zm5.27 0h3.72v1.24h.05c.52-.93 1.78-1.9 3.66-1.9 3.92 0 4.64 2.58 4.64 5.93V19H18.6v-4.05c0-.96-.02-2.2-1.34-2.2-1.34 0-1.55 1.05-1.55 2.13V19h-3.44V9.95Z"
      />
    </svg>
  ),
};

export default BrandLogos;
